const { CrudModel } = require('./crud');

export class ShiftKindModel extends CrudModel {
	constructor() {
		super('admin/shift_kind');
	}
}

export default new ShiftKindModel();
